import React, { useContext, useState } from 'react';
import { ReactComponent as Trash } from '../Assets/Icons/trashcan.svg';
import * as Tooltip from '@radix-ui/react-tooltip';
import { ReactComponent as ExclamationMark } from '../Assets/Icons/exclamation-mark.svg';
import { IconButton, IconButtonProps } from '../SubComponents/Buttons';
import styled from 'styled-components/macro';
import { Label } from '../SubComponents/Text';
import { graphqlSdk } from '../Utils/graphql-client';
import useTypeSafeLocalize from '../Hooks/use-type-safe-localize';
import { ErrorLocalization, LocalizationCategory } from '../localizations/types';
import { isWarrantyAppliedActionTypes } from '../redusers/is-warranty-applied-reducer';
import {
  bookingState,
  BookingStateCombinedState,
} from '../Pages/Booking/client-state/booking-state-context';
import {
  bookingEditState,
  BookingEditStateCombinedState,
} from '../Pages/BookingEdit/client-state/booking-edit-state-context';
import usePageType from '../Hooks/use-page-type';
export interface RemoveItemButtonProps {
  itemId: string;
}
const TooltipContent = styled(Tooltip.Content)`
  padding: 10px 15px;
  background: white;
  border-radius: 8px;
`;

const RemoveCancellationWarrantyButton = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const localize = useTypeSafeLocalize();
  const pageType = usePageType();

  // This hook is currently only used on the booking and edit-booking pages
  const { state: stateBooking, dispatch: dispatchBooking } = useContext(bookingState);
  const { state: stateBookingEdit, dispatch: dispatchBookingEdit } =
    useContext(bookingEditState);

  let state: BookingStateCombinedState['state'] | BookingEditStateCombinedState['state'];
  let dispatch:
    | BookingStateCombinedState['dispatch']
    | BookingEditStateCombinedState['dispatch'];

  switch (pageType) {
    case 'booking': {
      state = stateBooking;
      dispatch = dispatchBooking;
      break;
    }
    case 'edit-booking': {
      state = stateBookingEdit;
      dispatch = dispatchBookingEdit;
      break;
    }
    default: {
      state = stateBooking;
      break;
    }
  }

  const removeCancellationWarranty = async () => {
    if (state.booking.id) {
      try {
        setLoading(true);
        setError(false);
        await graphqlSdk.removeCancellationWarranty({
          bookingId: state.booking.id,
        });
        dispatch({
          type: isWarrantyAppliedActionTypes.SET_IS_APPLIED,
          payload: false,
        });
      } catch {
        setError(true);
        setLoading(false);
      }
    } else {
      dispatch({
        type: isWarrantyAppliedActionTypes.SET_IS_APPLIED,
        payload: false,
      });
    }
  };

  const iconButtonProps: IconButtonProps = {
    onClick: removeCancellationWarranty,
    icon: error ? ExclamationMark : Trash,
    width: '11px',
    height: '17px',
    pt: '1px',
    mr: '2',
    disabled: loading,
    loading: loading,
  };

  return error ? (
    <Tooltip.Root>
      <Tooltip.Trigger asChild>
        <span>
          <IconButton {...iconButtonProps} />
        </span>
      </Tooltip.Trigger>
      <Tooltip.Portal>
        <TooltipContent>
          <Label error>
            {localize(LocalizationCategory.error, ErrorLocalization.UnknownError)}
          </Label>
        </TooltipContent>
      </Tooltip.Portal>
    </Tooltip.Root>
  ) : (
    <IconButton {...iconButtonProps} />
  );
};

export default RemoveCancellationWarrantyButton;
